import { sendRequest } from "@infrastructure/api/api";
import type ApiResponse from "@core/types/apiResponse";
import type { ApiMessageResponse } from "@core/types/apiMessageResponse";

type ApproveBody = {
  notes: string;
};

type Args =
  | {
      scope: "church";
      churchId: number;
      departmentId: number;
      departmentReportId: number;
      notes: string;
    }
  | {
      scope: "district";
      districtId: number;
      departmentId: number;
      departmentReportId: number;
      notes: string;
    }
  | {
      scope: "nation";
      nationId: number;
      departmentId: number;
      departmentReportId: number;
      notes: string;
    };

function buildApproveUrl(args: Args): string {
  switch (args.scope) {
    case "church":
      return `/church/${args.churchId}/department/${args.departmentId}/report/approve/${args.departmentReportId}`;
    case "district":
      return `/district/${args.districtId}/department/${args.departmentId}/report/approve/${args.departmentReportId}`;
    case "nation": {
      const nationId = args.nationId;
      if (!nationId) {
        throw new Error("nationId is required for scope=nation");
      }
      return `/nation/${nationId}/department/${args.departmentId}/report/approve/${args.departmentReportId}`;
    }
    default: {
      const _exhaustive: never = args;
      return _exhaustive;
    }
  }
}

export async function requestReportApproveAsync(
  args: Args
): Promise<ApiResponse<ApiMessageResponse>> {
  const url = buildApproveUrl(args);

  return sendRequest<ApproveBody, ApiMessageResponse>("POST", url, { notes: args.notes });
}
